import { webRoutes } from '@local/utils'

import { HomeHeader_UserFragment } from '@web/federation/gql/graphql'
import { useGlobalStaticStateContext } from '@web/hooks/useGlobalStaticState'
import { useNavigation } from '@web/hooks/useNavigation'
import { DEFAULT_USER_NICKNAME } from '@web/libs/constants'
import links from '@web/libs/constants/links'
import { Nullish } from '@web/types'
import { HomeHeader } from '@web/ui/components/Header'

type Props = {
  user: Nullish<HomeHeader_UserFragment>
}

const HomeHeaderContainer = ({ user }: Props) => {
  const navigation = useNavigation()
  const { isFromMapsApp } = useGlobalStaticStateContext()

  const handleSettingClick = () => {
    if (!user) {
      navigation.goToLogin()
    } else {
      navigation.push({ url: webRoutes.SETTING })
    }
  }

  return (
    <HomeHeader
      login={!!user}
      nickname={user?.profile.nickname ?? DEFAULT_USER_NICKNAME}
      borderImageUrl={user?.profile.border?.imageUrl ?? undefined}
      profileImageUrl={user?.profile.imageUrl ?? undefined}
      onLoginClick={() => navigation.goToLogin()}
      showProfileOnScroll
      onMyplaceClick={() => navigation.push({ url: webRoutes.HOME })}
      onNaverClick={() => navigation.push({ url: links.NAVER })}
      onSettingClick={handleSettingClick}
      isFromMapsApp={isFromMapsApp}
    />
  )
}

export default HomeHeaderContainer
